import { render, staticRenderFns } from "./dipatch-point-out.vue?vue&type=template&id=3730b504&"
import script from "./dipatch-point-out.vue?vue&type=script&lang=js&"
export * from "./dipatch-point-out.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports